import React from 'react';
import Textbox from './Textbox';
import translate from '../../i18n/translate';

export default function TextboxContainer() {
  return (
    <div className="goals-box about-box">
      <div className="text-box-title">
        <h1>{translate('aboutUs')}</h1>
      </div>
      <Textbox title={translate('aboutUs')} path="/about">
        {translate('aboutUsHome', { tag: <br /> })}
      </Textbox>
    </div>
  );
}
